module.exports = function(aiModule) {
	'use strict'
    aiModule.directive('aiConfigurationDir',aiConfigurationDir);
	aiConfigurationDir.$inject=[];
	function aiConfigurationDir() {
		return {
			template: require('./partial/aiConfiguration.html'),
			controller:'aiConfigurationController',
			controllerAs:'vmaic',
			link: function(scope, element, attrs, ctrl) {
				    
			}

		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/aiModule/create-edit-configuration/js/directive/aiConfigurationDirective.js
// module id = 489
// module chunks = 0